import React, { useState, useEffect } from "react";
import apiService from "../../services/apiService";

const Tasks = ({ sfContext, sfAuthError, sfSession, refreshSfToken }) => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: "", text: "" });

    const [subject, setSubject] = useState("");
    const [dueDate, setDueDate] = useState("");
    const [priority, setPriority] = useState("High");

    const PRIORITIES = [
        { value: "Low", label: "Low" },
        { value: "Normal", label: "Normal" },
        { value: "High", label: "High" },
    ];

    useEffect(() => {
        // Pre-fill some defaults from sfContext if available
        if (sfContext && sfContext.accountName) {
            setSubject(`Send updated proposal - ${sfContext.accountName}`);
        } else if (sfContext && sfContext.accounts && sfContext.accounts.length > 0) {
            const acc = sfContext.accounts[0];
            setSubject(`Send updated proposal - ${acc.name}`);
        } else if (sfContext && sfContext.contacts && sfContext.contacts.length > 0) {
            const con = sfContext.contacts[0];
            setSubject(`Send updated proposal - ${con.name}`);
        } else {
            setSubject("Send updated proposal");
        }

        // Default dueDate to 2026-04-15 as per user payload (since today is Mar 26, 2026)
        setDueDate("2026-04-15");
    }, [sfContext]);

    const handleCreateTask = async () => {
        setLoading(true);
        setMessage({ type: "", text: "" });

        if (sfAuthError) {
            setMessage({ type: "error", text: "Salesforce access restricted. Task creation disabled." });
            setLoading(false);
            setTimeout(() => setMessage({ type: "", text: "" }), 5000);
            return;
        }

        if (!subject || !subject.trim()) {
            setMessage({ type: "error", text: "Subject is required." });
            setLoading(false);
            setTimeout(() => setMessage({ type: "", text: "" }), 5000);
            return;
        }


        if (!sfContext || Object.keys(sfContext).length === 0 || sfContext.matchFound === false) {
            setMessage({ type: "error", text: "Salesforce account not selected." });
            setLoading(false);
            setTimeout(() => setMessage({ type: "", text: "" }), 5000);
            return;
        }

        try {
            /*
            let token = sfSession?.accessToken;
            let instanceUrl = sfSession?.instanceUrl;

            if (!token || !instanceUrl) {
                const refreshed = await refreshSfToken?.();
                if (refreshed) {
                    token = refreshed.accessToken;
                    instanceUrl = refreshed.instanceUrl;
                } else {
                    setMessage({ type: "error", text: "Salesforce session expired. Please retry." });
                    setLoading(false);
                    return;
                }
            }

            let accountId = "";


            if (sfContext && sfContext.accountId) {
                accountId = sfContext.accountId;
            } else if (sfContext && sfContext.accounts && sfContext.accounts.length > 0) {
                accountId = sfContext.accounts[0].accountId;
            } else if (sfContext && sfContext.contacts && sfContext.contacts.length > 0) {
                accountId = sfContext.contacts[0].accountId; // Assumes contact has accountId
            }

            if (!accountId) {
                setMessage({ type: "error", text: "Salesforce account not selected." });
                setLoading(false);
                setTimeout(() => setMessage({ type: "", text: "" }), 5000);
                return;
            }

            const payload = {
                instance_url: instanceUrl,
                access_token: token,
                subject,
                description: "",
                dueDate,
                accountId,
                priority
            };


            const result = await apiService.createTask(payload);

            if (result.error) {
                setMessage({ type: "error", text: result.details || result.error });
            } else {
                setMessage({ type: "success", text: "Task created successfully!" });
            }
            */

            // Simulation of MOCK task creation in Salesforce
            await new Promise(resolve => setTimeout(resolve, 1200));
            setMessage({ type: "success", text: " Task created successfully in Salesforce!" });

            setTimeout(() => setMessage({ type: "", text: "" }), 5000);
        } catch (err) {
            console.error("Create task failed:", err);
            setMessage({ type: "error", text: "Failed to create task." });
            setTimeout(() => setMessage({ type: "", text: "" }), 5000);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="action-card">
            <div className="action-card-header">
                <span className="action-icon tasks-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2.5">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                </span>
                <span className="action-title">Tasks</span>
            </div>

            <div className="action-card-body">
                {message.text && (
                    <div className={`action-message ${message.type}`}>
                        {message.text}
                    </div>
                )}

                <div className="action-form-group">
                    <label className="action-label">Subject</label>
                    <input
                        type="text"
                        className="action-input"
                        placeholder="Task subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                    />
                </div>

                <div className="action-form-group">
                    <label className="action-label">Due Date</label>
                    <input
                        type="date"
                        className="action-input"
                        value={dueDate}
                        onChange={(e) => setDueDate(e.target.value)}
                        min={new Date().toISOString().split("T")[0]}
                    />

                </div>

                <div className="action-form-group">
                    <label className="action-label">Priority</label>
                    <select
                        className="action-input"
                        value={priority}
                        onChange={(e) => setPriority(e.target.value)}
                    >
                        {PRIORITIES.map((p) => (
                            <option key={p.value} value={p.value}>{p.label}</option>
                        ))}
                    </select>
                </div>

                <button
                    className="action-btn-primary full-width"
                    onClick={handleCreateTask}
                    disabled={loading}

                >
                    {loading ? "Posting..." : "Post Task"}
                </button>
            </div>
        </div>
    );
};

export default Tasks;
